<p-fieldset legend="Linked Child Courses">
  <p-message severity="secondary">
    <i class="pi pi-info-circle" style="font-size: 1.0rem"></i>&nbsp;This course is linked with the below child courses.
</p-message>
  <ul class="linked-courses-list">
    @for (item of contentItems(); track $index) {
      <li>
        <a href="javascript:void(0)" (click)="onLinkClick(item)">{{ item.title }}&nbsp;&nbsp;<i class="pi pi-external-link"></i></a>
      </li>
    }
  </ul>
</p-fieldset>